
import ApiError from '@/components/snackbars/ApiError.vue';
import { mapState } from 'vuex';

export default {
  components: {
    ApiError,
  },
  computed: {
    ...mapState('app', ['forceRerenderKey']),
  },
};
